module.exports = __webpack_public_path__ + "static/media/new.0dbcfe0d.mp3";